import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-version-banner',
  templateUrl: './version-banner.component.html',
  styleUrls: ['./version-banner.component.scss'],
  standalone: false,
})
export class VersionBannerComponent {
  @Output() refresh = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  onRefresh(): void {
    this.refresh.emit();
  }

  onDismiss(): void {
    this.dismiss.emit();
  }
}
